import { t } from "../i18n"
import { Controller } from "@hotwired/stimulus"
import { Chart, registerables } from "chart.js"

Chart.register(...registerables)

export default class extends Controller {
  static values = { config: Object }

  connect() {
    this.chart = new Chart(this.element, this.configValue)
  }

  disconnect() {
    this.chart?.destroy()
  }
}
